module.exports = __webpack_public_path__ + "img/diamond_icon.0873f7b7.png";